import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { V4_API_PREFIX } from '../../api-services.config';
import { Index } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class IndexService {
  private readonly http = inject(HttpClient);
  private readonly API_PREFIX = `${V4_API_PREFIX}index/`;

  public getIndex({ index_id }: { index_id: string }): Observable<Index> {
    return this.http.get<Index>(`${this.API_PREFIX}${index_id}`);
  }
}
